module.exports = __webpack_public_path__ + "static/img/mobile-web-bg@m.aeb98b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/mobile-web-bg@m.jpg
// module id = V2BO
// module chunks = 0